/*! parametrage migrateMute */
jQuery.migrateMute = false;